import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Field } from 'redux-form';

import Default from 'components/Input/Default';
import Select from 'components/Input/Select';
import YesNoOptions from 'components/Input/YesNoOptions';
import Label from 'components/Label';
import {
    PROFILE_RESIDENCE_TYPE,
    PROFILE_SALE_METHOD,
    PROFILE_SALE_SUPPORT_LEVEL,
    PROFILE_SELLER,
    PROFILE_SELLERS_REQUIRING_SUPPORT_LEVEL,
    PROFILE_STARTED_SELLING,
} from 'constants/Global';
import { isZoneMedia } from 'helpers/FormInformations';
import { translate } from 'helpers/Translate';
import { getSearchParamsAsObject } from 'helpers/Referrer';

const ProjectQuestions = ({ values, small }) => {
    const containerLabelClasses = classnames({
        'row-container__label': true,
        'row-container__label--small': small,
    });

    const containerFieldClasses = classnames({
        'row-container__field': true,
        'row-container__field--small': small,
    });

    const params = getSearchParamsAsObject();

    return (
        <div>
            <div className="row-container row-container--padding-bottom">
                <div className={containerLabelClasses}>
                    <Label
                        labelFor="profile_residence_type"
                        text={translate('Ce bien est')}
                        small={small}
                    />
                </div>
                <div className={containerFieldClasses}>
                    <Field
                        component={Select}
                        name="profile_residence_type"
                        options={PROFILE_RESIDENCE_TYPE}
                        emptyOption
                        small={small}
                    />
                </div>
            </div>
            <div className="row-container row-container--padding-bottom">
                <div className={containerLabelClasses}>
                    <Label
                        labelFor="profile_seller"
                        text={translate('Envisagez-vous de vendre ce bien ?')}
                        small={small}
                    />
                </div>
                <div className={containerFieldClasses}>
                    <Field
                        component={Select}
                        name="profile_seller"
                        options={PROFILE_SELLER}
                        emptyOption
                        small={small}
                    />
                </div>
            </div>
            {values.profile_seller === PROFILE_STARTED_SELLING && (
                <div className="row-container row-container--padding-bottom">
                    <div className={containerLabelClasses}>
                        <Label
                            labelFor="profile_sale_method"
                            text={translate("Par quels moyens l'avez-vous mis en vente ?")}
                            small={small}
                        />
                    </div>
                    <div className={containerFieldClasses}>
                        <Field
                            component={Select}
                            name="profile_sale_method"
                            options={PROFILE_SALE_METHOD}
                            emptyOption
                            small={small}
                        />
                    </div>
                </div>
            )}
            {PROFILE_SELLERS_REQUIRING_SUPPORT_LEVEL.includes(values.profile_seller) && (
                <div className="row-container row-container--padding-bottom">
                    <div className={containerLabelClasses}>
                        <Label
                            labelFor="profile_support_level"
                            text={translate(
                                "Quel niveau d'accompagnement vous conviendrait le mieux ?",
                            )}
                            small={small}
                        />
                    </div>
                    <div className={containerFieldClasses}>
                        <Field
                            component={Select}
                            name="profile_support_level"
                            options={PROFILE_SALE_SUPPORT_LEVEL}
                            emptyOption
                            small={small}
                        />
                    </div>
                </div>
            )}
            {!isZoneMedia(values) && (
                <div>
                    <div className="row-container row-container--padding-bottom">
                        <div className="row-container__label row-container__label--full-height">
                            <Label
                                labelFor="profile_optin_realtors"
                                text={
                                    <span>
                                        {translate('Souhaitez-vous être contacté')}
                                        <strong>{translate(' en priorité ')}</strong>
                                        {translate('par nos experts immobiliers ?')}
                                    </span>
                                }
                                small={small}
                            />
                        </div>
                        <div className="row-container__field row-container__field--yes-no">
                            <YesNoOptions
                                name="profile_optin_realtors"
                                small={small}
                                isEstimaUpdate={params?.estima_id}
                            />
                        </div>
                    </div>
                    {values.profile_optin_realtors && (
                        <div className="row-container row-container--padding-bottom">
                            <div className="row-container__label row-container__label--full-height">
                                <Label
                                    labelFor="user_phone"
                                    text={translate(
                                        'Veuillez confirmer votre numéro de téléphone.',
                                    )}
                                    subText={translate(
                                        'Ce service est gratuit et sans engagement.',
                                    )}
                                    small={small}
                                    infoLabel
                                />
                            </div>
                            <div className="row-container__field">
                                <Field
                                    component={Default}
                                    name="user_phone"
                                    placeholder={translate('Votre téléphone')}
                                    fullWidth
                                    autoComplete="tel"
                                    small
                                    value={values._initial_user_phone}
                                />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

ProjectQuestions.displayName = 'ProjectQuestions';

ProjectQuestions.propTypes = {
    values: PropTypes.shape({}).isRequired,
    small: PropTypes.bool,
};

/**
 * ProjectQuestions Functional Component.
 */
export default ProjectQuestions;
